import styled from 'styled-components';

export const Label = styled.span`
  font-size: 13px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.23;
  letter-spacing: 0.01px;
  text-align: left;
  color: #282828;
  margin-bottom: 10px;
  display: block;
  > span {
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.15;
    letter-spacing: 0.01px;
    text-align: left;
    color: #999999;
  }
`;

export const BoxInput = styled.div`
  /* 
    SELECT STYLES
  */

  .ant-select-disabled .ant-select-selection {
    background-color: #f6f6f6;
    color: #282828;
  }

  .ant-select-selection--single {
    height: 35px;
  }

  .ant-select-selection {
    background-color: #fff;
    box-shadow: inset 0px 1px 0px 0px #c7c7c794;
    border: 1px solid #c7c7c794;
  }

  .ant-select-selection:hover {
    border-color: #74a50a;
  }
  .ant-select-focused .ant-select-selection,
  .ant-select-selection:focus,
  .ant-select-selection:active {
    border-color: #74a50a;
    border-right-width: 1px !important;
    outline: 0;
    -webkit-box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }

  .ant-select-open .ant-select-selection {
    border-color: #74a50a;
  }

  .ant-select-dropdown.ant-select-dropdown--multiple
    .ant-select-dropdown-menu-item-selected
    .ant-select-selected-icon,
  .ant-select-dropdown.ant-select-dropdown--multiple
    .ant-select-dropdown-menu-item-selected:hover
    .ant-select-selected-icon {
    display: inline-block;
    color: #74a50a;
  }
`;
